<template>
  <div>
    <service-header :signedIn="signedInUser !== null"/>
    <b-container>
      <b-row>
        <b-col cols="12">
          <terms-of-service-content class="terms-of-service-content-wrapper"/>
        </b-col>
      </b-row>
    </b-container>
    <service-footer
      :signedIn="signedInUser !== null"
      :route="$route.name"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import TermsOfServiceContent from '@/components/molecules/TermsOfServiceContent.vue'
import ServiceHeader from '@/components/molecules/service/ServiceHeader.vue'
import ServiceFooter from '@/components/molecules/service/ServiceFooter.vue'

export default {
  name: 'ServiceTermsOfService',
  components: {
    TermsOfServiceContent,
    ServiceHeader,
    ServiceFooter
  },
  computed: {
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";

.terms-of-service-content-wrapper {
  padding: 80px 0 50px 0;

  @include mq(md) {
    padding: 130px 0 50px 0;
  }
}
</style>
